import { ComponentProps, useRef } from 'react';
import BaseDatePicker from 'react-date-picker';
import { Value } from 'react-date-picker/dist/cjs/shared/types';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
// import { ArrowRightIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';
// import { CalendarDaysIcon } from '@heroicons/react/24/solid';
// import { StyledDatePicker } from './date-picker.styles';
import { formatDateInputValue } from '@restworld/utils-common';
import TextInput from '../form/form.input';
import { Heading } from '@restworld/ui-ds-base';
import { InputProps } from '../form/form.types';

export type FieldState = 'normal' | 'error';

interface Props extends ComponentProps<typeof BaseDatePicker> {
  helperText?: string;
  fieldState?: FieldState;
  testId?: string;
  borderColor?: InputProps['bordercolor'];
}

export type DateType = Value;

export function DatePicker({ helperText, testId, borderColor, ...inputProps }: Props) {
  const mobileInputRef = useRef<HTMLInputElement>(null);
  const props: ComponentProps<typeof BaseDatePicker> = {
    // minDetail: inputProps.minDetail ?? 'decade',
    // openCalendarOnFocus: inputProps.openCalendarOnFocus ?? true,
    // selectRange: inputProps.selectRange ?? true,
    // tileClassName: inputProps.tileClassName ?? 'react-calendar-tile',
    // nextLabel:
    //   inputProps.tileClassName === undefined ? (
    //     <ArrowRightIcon className="w-4 h-4 inline hover:font-semibold" />
    //   ) : (
    //     inputProps.nextLabel
    //   ),
    // prevLabel:
    //   inputProps.tileClassName === undefined ? (
    //     <ArrowLeftIcon className="w-4 h-4 inline hover:font-semibold" data-cy={`${testId}-back-arrow`} />
    //   ) : (
    //     inputProps.prevLabel
    //   ),
    // next2Label: inputProps.next2Label ?? null,
    // prev2Label: inputProps.prev2Label ?? null,
    // calendarIcon: inputProps.calendarIcon ?? <CalendarDaysIcon className="w-5 h-5 inline" />,
    // clearIcon: inputProps.clearIcon ?? null,
    // fieldState: inputProps.fieldState ?? 'normal',
    ...inputProps,
  };

  // const onHandleClick = () => {
  //   if (mobileInputRef.current) mobileInputRef.current.showPicker?.();
  // };

  return (
    <div className="flex flex-col gap-2">
      {/* <StyledDatePicker {...props} /> */}
      <TextInput
        {...{
          id: props.id as string,
          type: 'date',
          value: formatDateInputValue(props.value),
          onChange: (value: string) => props.onChange?.(value as unknown as DateType),
          testId: testId,
          disabled: props?.disabled,
        }}
        bordercolor={borderColor}
        ref={mobileInputRef}
      />
      {!!helperText && <HelperTextRElement helperText={helperText} />}
    </div>
  );
}

export const HelperTextRElement = ({ helperText }: { helperText?: string }) =>
  helperText ? (
    <Heading as="span" size={6} weight="normal" color="error">
      {helperText}
    </Heading>
  ) : null;
